export const isDateInRange = (dateStr, filterDate, filterRange) => {
  const docDate = new Date(dateStr);
  docDate.setHours(0, 0, 0, 0);

  if (filterDate) {
    const compareDate = new Date(filterDate);
    compareDate.setHours(0, 0, 0, 0);
    if (docDate.getTime() === compareDate.getTime()) return true;
  }

  if (filterRange) {
    const [startDate, endDate] = filterRange;
    
    // If only start date is provided
    if (startDate && !endDate) {
      const start = new Date(startDate);
      start.setHours(0, 0, 0, 0);
      return docDate >= start;
    }
    
    // If only end date is provided
    if (!startDate && endDate) {
      const end = new Date(endDate);
      end.setHours(23, 59, 59, 999);
      return docDate <= end;
    }
    
    // If both dates are provided
    if (startDate && endDate) {
      const start = new Date(startDate);
      const end = new Date(endDate);
      start.setHours(0, 0, 0, 0);
      end.setHours(23, 59, 59, 999);
      return docDate >= start && docDate <= end;
    }
  }

  return !filterDate && !filterRange;
};

export const matchesGlobalSearch = (doc, searchTerm) => {
  if (searchTerm.trim() === '') return true;
  
  return Object.entries(doc).some(([key, value]) => {
    if (key === 'uploadDate') {
      const dateObj = new Date(value);
      if (!isNaN(dateObj.getTime())) {
        // Numeric: "02/01/2023"
        const formattedDateNumeric = dateObj.toLocaleDateString('en-US', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit'
        });
        // Short month: "Feb 01, 2023"
        const formattedDateShort = dateObj.toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'short',
          day: '2-digit'
        });
        // Long month: "February 1, 2023"
        const formattedDateLong = dateObj.toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        });
        // Date and time (short month)
        const formattedDateTime = dateObj.toLocaleString('en-US', {
          year: 'numeric',
          month: 'short',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit'
        });
        const searchTermLower = searchTerm.toLowerCase();
        return formattedDateNumeric.toLowerCase().includes(searchTermLower) ||
               formattedDateShort.toLowerCase().includes(searchTermLower) ||
               formattedDateLong.toLowerCase().includes(searchTermLower) ||
               formattedDateTime.toLowerCase().includes(searchTermLower);
      }
      return false;
    }
    return String(value).toLowerCase().includes(searchTerm.toLowerCase());
  });
};